import React from 'react';
import { useLanguage } from './hooks/useLanguage';
import { useScrollSpy } from './hooks/useScrollSpy';

// Import all components
import LanguageModal from './components/LanguageModal';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

function App() {
  // Language management
  const { 
    language, 
    changeLanguage, 
    showLanguageModal, 
    openLanguageModal, 
    translations: t 
  } = useLanguage();

  // Scroll spy functionality
  const { 
    activeSection, 
    sectionRefs, 
    scrollToSection 
  } = useScrollSpy();

  return (
    <div className="min-h-screen bg-white">
      {/* Language Selection Modal */}
      <LanguageModal
        showModal={showLanguageModal}
        onLanguageSelect={changeLanguage}
        translations={t}
      />

      {/* Navigation */}
      <Navigation
        activeSection={activeSection}
        scrollToSection={scrollToSection}
        language={language}
        onLanguageModalOpen={openLanguageModal}
        translations={t}
      />

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <HeroSection
          sectionRef={sectionRefs.home}
          scrollToSection={scrollToSection}
          translations={t}
        />

        {/* Services Section */}
        <ServicesSection
          sectionRef={sectionRefs.services}
          translations={t}
        />

        {/* About Section */}
        <AboutSection
          sectionRef={sectionRefs.about}
          translations={t}
        />

        {/* Contact Section */}
        <ContactSection
          sectionRef={sectionRefs.contact}
          translations={t}
          language={language}
        />

        {/* FAQ Section */}
        <FAQSection
          sectionRef={sectionRefs.faq}
          translations={t}
        />
      </main>

      {/* Footer */}
      <Footer
        translations={t}
      />
    </div>
  );
}

export default App;